<template>
  <div class="">

    <div v-if="flash" class="p-5 w-full rounded border-blue-200 bg-blue-100 text-blue-900 border">
      {{ flash }}
    </div>

    <div>
      <h2>Alarm Settings</h2>
    </div>

    <alarm-settings-edit-groups
        v-model:show="showAlarmSetting"
        :alarmSetting = "selectedAlarmSetting"
        v-on:update:setting="updateSettingFromEditModal($event)"
    ></alarm-settings-edit-groups>

    <!-- Table -->
    <ajax-table :data="data"
                :headers="headers"
                v-model:loading="ajaxTable.loading"
                v-model:search="ajaxTable.search"
                v-model:sort-by="ajaxTable.sortBy"
                v-model:sort-desc="ajaxTable.sortDesc"
                v-model:page="ajaxTable.page"
                v-model:items-per-page="ajaxTable.itemsPerPage"
                v-model:page-info="ajaxTable.pageInfo"
                :exportable="false"
                @loadData="getData"
                @rowSelected="showAlarmSettingModal"
    >

        <template #above_table_center>
            <div class="flex flex-row items-center justify-start gap-4">
                <button-blue-secondary class="py-3 max-w-none sm:max-w-48" @click="exportAlarmSettings">Export</button-blue-secondary>
            </div>
        </template>

      <!-- Column 1: Area -->
      <template #col-1="props">
        <div    class="flex flex-col items-start justify-center">
                    <span   class="my-1 text-gray-700">
                        {{ props.row.area }}
                    </span>
        </div>
      </template>

      <!-- Column 2: Zone -->
      <template #col-2="props">
        <div    class="flex flex-col items-start justify-center">
                    <span   class="my-1 text-gray-700">
                        {{ props.row.zone}}
                    </span>
        </div>
      </template>
      <!-- Column 3: Users -->
      <template #col-3="props">
        <div class="flex items-start flex-wrap">
          <div v-for="(username, id) in props.row.active_alarm_users">
                        <span class="inline-flex items-center m-1 px-2.5 py-0.5 rounded-md text-md font-medium bg-blue-100 text-blue-800">
                            {{  username }}
                        </span>
          </div>
        </div>
      </template>

    <!-- Column 4: Groups -->
      <template #col-4="props">
        <div class="flex items-start flex-wrap">
          <div v-for="group in props.row.groups">
            <span
              :class="getGroupAlarmsEnabled(group) ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'"
              class="inline-flex items-center m-1 px-2.5 py-0.5 rounded-md text-md font-medium">
              <svg v-if="getGroupAlarmsEnabled(group)"
                   class="-ml-0.5 mr-1.5 h-2 w-2 text-green-600" fill="currentColor" viewBox="0 0 8 8">
                <circle cx="4" cy="4" r="3" />
              </svg>
              {{  group.GroupName }}
            </span>
          </div>
        </div>

      </template>

    </ajax-table>
  </div>
</template>

<script>

import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import Pagination from "@/components/Pagination"
import ItemsPerPageSelect from "@/components/ItemsPerPageSelect"
import FloatingInput from "@/components/elements/FloatingInput";
import Select2 from '@/components/elements/select2'
import GreenButton from "@/components/elements/green-button";
import AjaxTable from "@/components/elements/AjaxTable";
import {ajaxTableMixin} from "@/mixins/ajaxTableMixin";
import Loading from "@/components/elements/loading";
import SmallColoredCheck from "@/components/elements/SmallColoredCheck";
import {UrlParamsMixin} from "@/mixins/UrlParamsMixin";
import _isNil from "lodash";
import GroupsEdit from "@/components/Groups/GroupsEdit";
import AlarmProfilesEdit from "@/components/alarmProfiles/alarmProfilesEdit";
import AlarmSettingsEdit from "@/components/AlarmSettingsEdit";
import ButtonBlueSecondary from "@/components/elements/buttons/ButtonBlueSecondary.vue";

export default {
  name: "AlarmSettingsIndexGroups",
  mixins: [SonicuCoreMixin, iconNamesMixin, ajaxTableMixin, UrlParamsMixin],
  components: {
      ButtonBlueSecondary,
    AlarmSettingsEdit,
    AlarmProfilesEdit,
    SmallColoredCheck,
    GroupsEdit,
    Loading, AjaxTable, GreenButton, Pagination, ItemsPerPageSelect, FloatingInput, Select2
  },
  props: {
    users: Object
  },
  data() {
    return {
      data: [],
      headers: [
        {
          name: 'Area',
          sortBy: 'area',
          show: 'sm',
          key: 'area',
        },
        {
          name: 'Zone',
          sortBy: 'zone',
          show: 'md',
          key: 'zone',
        },
        {
          name: 'Users',
          sortBy: '',
          show: 'md',
          key: 'users',
        },
        {
          name: 'Groups (• alarms enabled)',
          sortBy: '',
          show: 'md',
          key: 'groups',
        },
      ],
      requestNumber: 0,

      // For Modal
      showAlarmSetting: false,
      selectedAlarmSetting: null,
      selectedAlarmSettingIndex: null,
      preLoadAlarmSetting: null,

      exportFlag: false,
      flash: ''
    }
  },
  created() {
    this.ajaxTable.sortBy = 'area'
  },
  mounted() {
    this.preLoadGroup = this.urlParamsGet('alarm_setting')
  },
  methods: {
    getData() {
      this.ajaxTable.loading = true
      this.requestNumber++
      let params = this.constructParamsForRequest()

      axios.get(this.company.buildCompanyApiInternalRoute('alarm-settings'),
          {
            params: params,
          }
      ).then(response => {
        let data = response.data.data;
        data.meta = {};
        data.meta.current_page = data.current_page;
        data.meta.from = data.from;
        data.meta.to = data.to;
        data.meta.path = data.path;
        data.meta.per_page = data.per_page;
        data.meta.last_page = data.last_page;
        data.meta.requestNumber = response.data.requestNumber;
        if (data.meta.requestNumber !== `${this.requestNumber}`) {
          return
        }
        this.ajaxUpdateTableData(data); // This sends the data to the mixin for AjaxTable

        this.data = !_.isNil(data.data) ? data.data : [];

        this.flash = response.data.flash;

      }).catch(error => {
        console.log(error)
      }).then(() => {
        this.ajaxTable.loading = false
        this.exportFlag = false

          if (this.flash) {
              setTimeout(() => {
                  this.flash = '';
              }, 5000);
          }
      })
    },
    showAlarmSettingModal(rowIndex) {
      this.selectedAlarmSetting = this.data[rowIndex];
      this.showAlarmSetting = true;
      this.selectedAlarmSettingIndex = rowIndex;
    },
    getUserAdminStatus(userId){
      return this.admins.includes(userId);
    },
    updateSettingFromEditModal(foo){
      this.data[this.selectedAlarmSettingIndex] = foo
    },
    getGroupAlarmsEnabled(group){
      return group.pivot.group_alarm_enabled;
    },
    constructParamsForRequest() {
      let params = JSON.parse(JSON.stringify(this.ajaxTable))
      params.pageInfo = null
      params.requestNumber = this.requestNumber

      if (this.exportFlag) {
        params.export = this.exportFlag;
      }

      return params
    },
    exportAlarmSettings() {
      this.exportFlag = true;
      this.getData();
    }
  },
  computed: {},
  watch: {
  },
}
</script>

<style scoped>

</style>